import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const location = useLocation();
  const [cartItems, setCartItems] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const cartRef = useRef(null);

  useEffect(() => {
    const updateCart = () => {
      const cart = JSON.parse(localStorage.getItem("cart") || "[]");
      setCartItems(cart);
    };

    updateCart();
    window.addEventListener("storageUpdate", updateCart);

    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("storageUpdate", updateCart);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cartRef.current && !cartRef.current.contains(event.target)) {
        setShowCart(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  const removeFromCart = (id) => {
    const updatedCart = cartItems.filter((item) => item.id !== id);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    setCartItems(updatedCart);
    window.dispatchEvent(new Event("storageUpdate"));
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (showCart) setShowCart(false);
  };

  const closeAllMenus = () => {
    setIsMobileMenuOpen(false);
    setShowCart(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar__logo">Kothari Luggage Mall</div>

      <button
        className={`navbar__hamburger ${isMobileMenuOpen ? "navbar__hamburger--active" : ""}`}
        onClick={toggleMobileMenu}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul className={`navbar__links ${isMobileMenuOpen ? "navbar__links--active" : ""}`}>
        <li><Link to="/#home" onClick={closeAllMenus}>Home</Link></li>
        <li><Link to="/#brands" onClick={closeAllMenus}>Brands</Link></li>
        <li><Link to="/#categories" onClick={closeAllMenus}>Categories</Link></li>
        <li><Link to="/#hot-picks" onClick={closeAllMenus}>Hot Picks</Link></li>
        <li><Link to="/#about" onClick={closeAllMenus}>About</Link></li>
        <li><Link to="/#contact" onClick={closeAllMenus}>Reach Us</Link></li>
      </ul>

      <div className="navbar__cart" ref={cartRef}>
        <div
          className="navbar__cart-icon"
          onClick={() => {
            setShowCart(!showCart);
            if (isMobileMenuOpen) setIsMobileMenuOpen(false);
          }}
        >
          🛒 <span className="navbar__cart-count">{cartItems.length}</span>
        </div>

        {showCart && (
          <div className="navbar__cart-dropdown">
            <h3 className="navbar__cart-title">Your Cart</h3>
            {cartItems.length === 0 ? (
              <p className="navbar__cart-empty">Cart is empty</p>
            ) : (
              <>
                <div className="navbar__cart-items">
                  {cartItems.map((item) => (
                    <div key={item.id} className="navbar__cart-item">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="navbar__cart-item-image"
                      />
                      <div className="navbar__cart-item-details">
                        <p className="navbar__cart-item-name">{item.name}</p>
                        <p className="navbar__cart-item-price">
                          ₹{item.price} x {item.quantity}
                        </p>
                        <button
                          className="navbar__cart-item-remove"
                          onClick={() => removeFromCart(item.id)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                <button
                  className="navbar__checkout-btn"
                  onClick={() => (window.location.href = "/checkout/cart")}
                >
                  Checkout
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;